export const ABORT_SENTRY_ERROR_MESSAGE = 'Promise Cancelled';

export const FEATURE_REQUEST_HANDLER = 'Upvoty';
